import getUrlImageUtil from 'components/Image/utils/get-url'

export default function getExtensionImageComponentUtil (src) {
  src = getUrlImageUtil(src)
  return src.slice(src.lastIndexOf('.'))
}
